import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import { PrimaryButton, TextButton } from '@bibliocommons/deprecated-base-buttons';
import { Return as ReturnIcon } from '@bibliocommons/deprecated-base-icons';
import ReturnDigitalCheckoutsModal from 'app/components/shared/ItemTransactions/components/digital-checkouts/ReturnDigitalCheckoutsModal';
import ThirdPartyReaderLink from './ThirdPartyReaderLink';
import DownloadCheckoutLink from './DownloadCheckoutLink';
import DigitalHelpLink from './DigitalHelpLink';
import QuickStartLink from './QuickStartLink';
import './CheckedOutReadingLinks.scss';

export default class CheckedOutReadingLinks extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  startDigitalMissingFormatSelection(e) {
    e.preventDefault();
    this.props.startDigitalMissingFormatSelection(this.props.metadataId);
  }

  handleReturnModalOpen() {
    this.props.modalActions.openModal(this.getReturnModalKey());
  }

  getReturnModalKey() {
    return `return-checkedout-item-modal-${this.props.metadataId}`;
  }

  renderCheckInLink() {
    if (this.props.checkInEnabled) {
      return (
        <TextButton className="btn btn-link" handleClick={this.handleReturnModalOpen} disabled={this.props.disabled}>
          <ReturnIcon />
          <FormattedMessage id="digital_return_now" />
        </TextButton>
      );
    }

    return null;
  }

  renderDownloadLink() {
    const { policy, downloadable, thirdPartyReaderUrl, format, downloadUrl, provider } = this.props;
    const showLink = policy.get('supportsDownload') && (downloadable || !thirdPartyReaderUrl) && format && downloadUrl;

    if (showLink) {
      return (
        <DownloadCheckoutLink
          className="btn btn-primary"
          downloadUrl={downloadUrl}
          format={format}
          provider={provider}
        />
      );
    }

    return null;
  }

  renderHelpLink() {
    const { policy, thirdPartyReaderUrl, format, downloadUrl } = this.props;

    const supportsDownload = policy.get('supportsDownload');

    if (!supportsDownload) {
      return <QuickStartLink policy={policy} className="btn btn-link" withIcons />;
    }

    const showLink = supportsDownload && !thirdPartyReaderUrl && format && !downloadUrl;

    if (showLink) {
      return <DigitalHelpLink policy={policy} className="btn btn-link" />;
    }

    return null;
  }

  renderChooseFormatButton() {
    const { policy, downloadable, thirdPartyReaderUrl, format } = this.props;

    const showButton = policy.get('supportsDownload') && (downloadable || !thirdPartyReaderUrl) && !format;

    if (showButton) {
      return (
        <PrimaryButton
          disabled={this.props.disabled}
          handleClick={this.startDigitalMissingFormatSelection}
          className="download-missing-format"
        >
          <FormattedMessage id="download" />
        </PrimaryButton>
      );
    }

    return null;
  }

  renderThirdPartyReaderLink() {
    const { thirdPartyReaderUrl, provider } = this.props;
    if (thirdPartyReaderUrl) {
      return (
        <ThirdPartyReaderLink
          className="btn btn-link"
          provider={provider}
          thirdPartyReaderUrl={thirdPartyReaderUrl}
          withIcons
        />
      );
    }

    return null;
  }

  render() {
    const thirdPartyReaderLink = this.renderThirdPartyReaderLink();
    const checkInLink = this.renderCheckInLink();
    const helpLink = this.renderHelpLink();
    const displayAccessLinks = !!thirdPartyReaderLink || !!checkInLink || !!helpLink;

    return (
      <div className="cp-checked-out-reading-links">
        {this.renderDownloadLink()}
        {this.renderChooseFormatButton()}
        {displayAccessLinks && (
          <div className="access-title-block">
            {thirdPartyReaderLink}
            {checkInLink}
            {helpLink}
          </div>
        )}
        <ReturnDigitalCheckoutsModal
          modalKey={this.getReturnModalKey()}
          modalActions={this.props.modalActions}
          bib={this.props.bib}
          shelfActions={this.props.shelfActions}
          checkIn={this.props.checkIn}
          checkoutId={this.props.checkoutId}
          metadataId={this.props.metadataId}
          accountId={this.props.accountId}
          messagingId={this.props.messagingId}
        />
      </div>
    );
  }
}

CheckedOutReadingLinks.propTypes = {
  checkInEnabled: PropTypes.bool,
  disabled: PropTypes.bool,
  policy: ImmutablePropTypes.mapContains({
    thirdPartyReaderUrl: PropTypes.string,
    supportsDownload: PropTypes.bool,
    quickstartUrl: PropTypes.string,
    helpUrl: PropTypes.string
  }),
  provider: PropTypes.string,
  checkoutId: PropTypes.string.isRequired,
  metadataId: PropTypes.string.isRequired,
  accountId: PropTypes.number.isRequired,
  downloadable: PropTypes.bool,
  downloadUrl: PropTypes.string,
  format: PropTypes.string,
  checkIn: PropTypes.func.isRequired,
  startDigitalMissingFormatSelection: PropTypes.func.isRequired,
  messagingId: PropTypes.string,
  bib: PropTypes.object,
  modalActions: PropTypes.objectOf(PropTypes.func),
  shelfActions: PropTypes.objectOf(PropTypes.func),
  thirdPartyReaderUrl: PropTypes.string
};
